export function* lazyMapFilter<T, R>(
  iterable: Iterable<T>,
  mapper: (item: T) => R | undefined | null,
): Generator<R> {
  for (const item of iterable) {
    const result = mapper(item);
    if (result != null) {
      yield result;
    }
  }
}

export function filterMap<T, R>(
  iterable: Iterable<T>,
  mapper: (item: T) => R | undefined | null,
) {
  return Array.from(lazyMapFilter(iterable, mapper));
}

const lazyUtils = {
  lazyMapFilter,
  filterMap,
};

export default lazyUtils;
